import React from 'react';
import { GridCell, Grid, Page } from 'styles';
import { copyFor } from 'config';
import { CleanKwhProvider } from 'contexts/clean-kwh';
import { PageHeading } from 'components/page-heading';

const getCopy = copyFor('usage');

interface Props {
  additional: React.ReactNode;
  breakdown: React.ReactNode;
  graph: React.ReactNode;
  project: React.ReactNode;
  recs: React.ReactNode;
  summary: React.ReactNode;
  testId: string;
}

export const Layout = (props: Props) => {
  const { additional, breakdown, graph, project, recs, summary, testId } =
    props;
  return (
    <CleanKwhProvider>
      <Page small={{ padding: '0 0 24px' }} data-testid={testId}>
        <PageHeading page={getCopy('heading')} />
        <Grid width="100%" gap="24px">
          <GridCell rows={4} columns={5} small={{ columnStart: 1, columns: 8 }}>
            {summary}
          </GridCell>
          <GridCell
            columnStart={6}
            columns={7}
            small={{ columnStart: 1, columns: 8 }}
          >
            {graph}
          </GridCell>
          <GridCell
            columnStart={6}
            columns={7}
            small={{ columnStart: 1, columns: 8 }}
          >
            {project}
          </GridCell>
          <GridCell
            columnStart={6}
            columns={7}
            small={{ columnStart: 1, columns: 8 }}
          >
            {breakdown}
          </GridCell>
          <GridCell
            columnStart={6}
            columns={7}
            small={{ columnStart: 1, columns: 8 }}
          >
            {recs}
          </GridCell>
          <GridCell
            columnStart={6}
            columns={7}
            small={{ columnStart: 1, columns: 8 }}
          >
            {additional}
          </GridCell>
        </Grid>
      </Page>
    </CleanKwhProvider>
  );
};
